import stbAPIGateway from '../../../../services/stbAPIGateway';

export const patchClientStudentManagementGrouping = async (
  { rootGetters },
  { clientSid, payload }
) => {
  const axios = rootGetters['app/stbAxios'];
  const apiUrl = process.env.API_URL || '';
  const stbApi = stbAPIGateway(axios, apiUrl);
  const response = await stbApi.patchClientStudentManagementGrouping(clientSid, payload);
  return response;
};
